import { AnyAction } from 'redux';
import { PaginatedResponse } from '@synergy/api';
import { SearchParams } from '@synergy/models';
import { sortByProperty } from '@synergy/utils';

import { Customer } from '../models/customer';
import {
    RECEIVE_CUSTOMERS,
    REQUEST_CUSTOMERS,
    RESET_CUSTOMERS_SEARCH,
    UPDATE_CUSTOMERS_SEARCH_PARAMS,
} from '../actions/customer-actions';

export interface CustomerReducerState {
    paginatedData: PaginatedResponse<Customer>;
    sortedByName: Customer[];
    searchParams: SearchParams;
    requestingCustomer: boolean;
}
const initialCustomerReducerState: CustomerReducerState = {
    paginatedData: { limit: 10, page: 0, total: 0, items: [] },
    sortedByName: [],
    searchParams: {},
    requestingCustomer: false,
};

export const customerReducer = (
    state: CustomerReducerState = initialCustomerReducerState,
    action: AnyAction
): CustomerReducerState => {
    const { type, ...rest } = action;
    switch (type) {
        case REQUEST_CUSTOMERS: {
            return {
                ...state,
                requestingCustomer: true,
            };
        }

        case RECEIVE_CUSTOMERS: {
            return {
                ...state,
                paginatedData: action['customers'],
                sortedByName: sortByProperty({ data: action['customers'].items, key: 'name' }),
                requestingCustomer: false,
            };
        }

        case UPDATE_CUSTOMERS_SEARCH_PARAMS: {
            return {
                ...state,
                searchParams: rest['customersSearchParams'],
                requestingCustomer: true,
            };
        }

        case RESET_CUSTOMERS_SEARCH: {
            return initialCustomerReducerState;
        }

        default: {
            return state;
        }
    }
};
